import Header from '../components/header'
import sharedStyles from '../styles/shared.module.css'

const QuestionsWrapper = () => {
  return (
    <>
      <Header titlePre="Therapist" />
      <div className={sharedStyles.layout}>
        <iframe src="/questions.html" title="questions" seamless={true} scrolling="no"></iframe>
      </div>
    </>
  )
}

export default QuestionsWrapper
